export const REDIRECT_MAP = {
  samoa: '/puppies-for-sale/american-samoa',
  lowShedding: '/puppies-for-sale/hypoallergenic',
  'weimaraner-1': '/puppies-for-sale/weimaraner',
  'german-shepherd': '/puppies-for-sale/german-shepherd-dog',
  cavadoodles: '/puppies-for-sale/cavapoo',
  'golden-bernedoodle': '/puppies-for-sale/golden-mountain-doodle',
  'papi-tzu': '/puppies-for-sale/papastzu',
  'central-asian-shepherd-dog-1':
    '/puppies-for-sale/central-asian-shepherd-dog',
  mini: '/puppies-for-sale/small',
  family: '/puppies-for-sale/kid_friendly',
  doodles: '/puppies-for-sale/doodle',
  companion: '/puppies-for-sale/emotional_support',
  'Yorkie-Bichon-Mix': 'yorkie-bichon-mix',
  poodle: 'standard-poodle',
}
